var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9bc15",
    d: "M15.32 3H8.68a1.009 1.009 0 0 0-.7.29L3.29 7.98a1.009 1.009 0 0 0-.29.7v6.63a1.033 1.033 0 0 0 .29.71l4.68 4.68a1.017 1.017 0 0 0 .71.3h6.63a1.033 1.033 0 0 0 .71-.29l4.68-4.68a.99.99 0 0 0 .29-.71V8.68a1.033 1.033 0 0 0-.29-.71l-4.68-4.68a1.009 1.009 0 0 0-.7-.29zM12 17.3a1.3 1.3 0 1 1 1.3-1.3 1.3 1.3 0 0 1-1.3 1.3zm0-4.3a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon_warning.5bf00dcba5560c68bb50d66ccff4b615.svg";
export { ForwardRef as ReactComponent };